import { useAuth } from '../contexts/AuthContext';

export function usePermissions() {
  const { userProfile } = useAuth();

  const isAdmin = userProfile?.role === 'admin';
  const isPro = userProfile?.role === 'pro' || isAdmin;

  return {
    isAdmin,
    isPro,
    canAccessMeditations: isPro,
    canAccessMoodTracker: isPro,
    canAccessTimeManagement: isPro,
    canAccessChallenges: isPro,
    canAccessRelaxation: isPro,
    canExportReports: isPro,
    canManageReminders: isPro
  };
}

export default usePermissions;